import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type IPhoneNoInputProps,
  PhoneNoInput,
} from "src/shared/forms/inputs/PhoneNoInput";

export interface IContactPhoneNoInputProps extends IPhoneNoInputProps {}

export const ContactPhoneNoInput = ({
  label = <FormattedMessage id="contacts.phone_no" />,
  isRequired = false,
  ...rest
}: IContactPhoneNoInputProps) => (
  <PhoneNoInput
    {...rest}
    label={label}
    isRequired={isRequired}
    minLength={9}
    maxLength={15}
  />
);
